module.exports = __webpack_public_path__ + "static/media/info-banner-light.2393b827.svg";